import { gql } from '@apollo/client';

export default gql`
  mutation markAllNotificationsAsRead($kind: [String!]) {
    markAllNotificationsAsRead(input: { kind: $kind }) {
      success
    }
  }
`;
